<div class="manual-backdrop" (click)="dismiss()"></div>
<h4 class="form__header">
  {{ title }}
  <div class="form__dismiss" (click)="dismiss()">
    <mat-icon>clear</mat-icon>
  </div>
</h4>

<div class="form__body" [formGroup]="form">
  <div class="form__input-wrapper">
    <app-custom-select
      formControlName="startCharacteristicId"
      placeholder="Характеристика начала"
      [required]="true"
      [items]="'MbimCharacteristic'"
      [itemsApiPrefix]="apiPrefix"
      [itemsSystemName]="data.systemName || 'bop'"
      [key]="'name'"
      [search]="['name']"
      [startSearchAtChar]="1"
    >
      <div
        *ngIf="startCharacteristicError$ | async as startCharacteristicError"
        class="input-hint input-hint--alert"
      >
        {{ startCharacteristicError }}
      </div>
    </app-custom-select>
  </div>

  <div class="form__input-wrapper">
    <app-custom-select
      formControlName="endCharacteristicId"
      placeholder="Характеристика окончания"
      [items]="'MbimCharacteristic'"
      [itemsApiPrefix]="apiPrefix"
      [itemsSystemName]="data.systemName || 'bop'"
      [key]="'name'"
      [search]="['name']"
      [startSearchAtChar]="1"
      [excludeIds]="endCharacteristicExcludeIds"
    ></app-custom-select>
  </div>

  <div class="form__input-wrapper form__input-wrapper--tooltip">
    <app-custom-select
      formControlName="startMilestoneIds"
      placeholder="События начала"
      [required]="true"
      [multiple]="true"
      [clearable]="true"
      [items]="'milestone'"
      [itemsApiPrefix]="apiPrefix"
      [itemsSystemName]="data.systemName || 'bop'"
      [key]="'name'"
      [search]="['name']"
      [startSearchAtChar]="1"
      (selectFocus)="showMilestoneTooltip('startMilestone')"
    >
      <div
        *ngIf="startMilestoneError$ | async as startMilestoneError"
        class="input-hint input-hint--alert"
      >
        {{ startMilestoneError }}
      </div>
    </app-custom-select>
    <div
      *ngIf="activeMilestoneTooltip === 'startMilestone'"
      class="form__tooltip form__tooltip--above"
    >
      {{ milestoneTooltipText }}
    </div>
  </div>

  <div class="form__input-wrapper form__input-wrapper--tooltip">
    <app-custom-select
      formControlName="endMilestoneIds"
      placeholder="События окончания"
      [multiple]="true"
      [clearable]="true"
      [items]="'milestone'"
      [itemsApiPrefix]="apiPrefix"
      [itemsSystemName]="data.systemName || 'bop'"
      [key]="'name'"
      [search]="['name']"
      [startSearchAtChar]="1"
      [excludeIds]="endMilestoneExcludeIds"
      (selectFocus)="showMilestoneTooltip('endMilestone')"
    >
    </app-custom-select>
    <div
      *ngIf="activeMilestoneTooltip === 'endMilestone'"
      class="form__tooltip form__tooltip--above"
    >
      {{ milestoneTooltipText }}
    </div>
  </div>

  <div class="form__input-wrapper">
    <app-input
      class="cell-input"
      placeholder="Процесс"
      formControlName="process"
      [required]="true"
    >
      <div *ngIf="processError$ | async as processError" class="input-hint input-hint--alert">
        {{ processError }}
      </div>
    </app-input>
  </div>

  <div class="form__input-wrapper">
    <app-input
      type="number"
      class="cell-input"
      [appInputFilter]="'[0-9]'"
      placeholder="Порядок"
      formControlName="order"
      [required]="true"
    >
      <div *ngIf="orderError$ | async as orderError" class="input-hint input-hint--alert">
        {{ orderError }}
      </div>
    </app-input>
  </div>
</div>

<div class="form__footer">
  <div class="form__actions">
    <button
      mat-raised-button
      class="form__action form__action--right"
      (click)="dismiss()"
    >
      Отменить
    </button>
    <button
      ymGoal
      [trackOn]="trackOn"
      mat-raised-button
      color="primary"
      class="form__action"
      [disabled]="form.invalid || isSaving"
      (click)="save()"
    >
      {{ submitLabel }}
    </button>
  </div>
</div>

<div *ngIf="confirmationVisible" class="confirmation">
  <div class="confirmation__body">
    <div class="confirmation__text">
      Вы действительно хотите выйти из карточки?
      <br />
      Введенные данные не сохранятся.
    </div>
    <div class="confirmation__actions">
      <button
        mat-raised-button
        class="form__action"
        (click)="confirmedDismiss(false)"
      >
        Нет
      </button>
      <button
        mat-raised-button
        color="primary"
        class="form__action"
        (click)="confirmedDismiss(true)"
      >
        Да
      </button>
    </div>
  </div>
</div>
